const ROWS = [
  { task: "Line-by-line audit vs. P-pages & OEM procedures", owner: "Agent" },
  { task: "DEG precedent matched to each dispute", owner: "Agent" },
  { task: "Supplement packet drafted for your one-tap approval", owner: "Agent + You" },
  { task: "Every rebuttal response drafted same-day", owner: "Agent" },
  { task: "Follow-ups queued on the carrier's response clock", owner: "Agent" },
  { task: "Organized escalation file for your appraiser or attorney", owner: "Agent" },
  { task: "Payment reconciled to your repair order", owner: "Agent" },
];

const Checklist = () => (
  <section
    data-testid="checklist-section"
    className="py-20 sm:py-28 bg-white border-b border-[#E7E5E4]"
  >
    <div className="max-w-4xl mx-auto px-4 sm:px-6">
      <div className="mb-10">
        <span className="text-xs font-bold uppercase tracking-widest text-[#9A3412]">
          Fully handled
        </span>
        <h2 className="text-3xl sm:text-4xl font-normal text-stone-900 font-serif-display mt-2">
          Everything your estimator stopped having time for.
        </h2>
        <p className="text-sm text-stone-600 mt-3 max-w-xl leading-relaxed">
          The average disputed claim costs a shop two hours of skilled labor — so
          short pays under $500 get eaten. Brim's agents fight every line on
          every claim, because their time costs nothing and their memory never
          resets.
        </p>
      </div>

      <div className="rounded-lg border border-stone-200 bg-[#FAF8F5] overflow-hidden">
        {ROWS.map((row, i) => (
          <div
            key={row.task}
            data-testid={`checklist-row-${i + 1}`}
            className="flex items-center justify-between gap-4 px-5 py-4 border-b border-stone-200 last:border-b-0"
          >
            <span className="text-sm text-stone-800">{row.task}</span>
            <span
              className={`text-xs font-mono-ui font-bold px-2.5 py-1 rounded shrink-0 ${
                row.owner === "Agent"
                  ? "bg-stone-200/80 text-stone-700"
                  : "bg-[#9A3412]/10 text-[#9A3412]"
              }`}
            >
              {row.owner}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-8">
        <a
          href="#interest-form"
          data-testid="checklist-cta"
          className="text-xs font-bold uppercase tracking-widest text-[#9A3412] hover:text-[#7C2D12] transition-colors"
        >
          Stop eating short pays →
        </a>
      </div>
    </div>
  </section>
);

export default Checklist;
